import React from "react";
import {Link} from "react-router-dom";
import {firestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import {compose} from "redux";
import {List, Avatar, Skeleton, notification, Row, Table, Input, Button, Space, Col, Switch, Form, InputNumber} from "antd";
import { SearchOutlined } from '@ant-design/icons';
import firebase from "../../Config/fbConfig"
import Highlighter from 'react-highlight-words';
import ItemDrawer from "../Items/ItemDrawer";
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import {createItem, createShopItem, deleteShopItem, updateItem, updateShopItem} from "../../Store/Actions/item";
const { Column } = Table;
const { Search } = Input;


class ShopItems extends React.Component {

    state = {
        visible: false,
        item: null,
        searchText: '',
        searchedColumn: '',
        itemState: "add",
        loading: false,
        initLoading: false,
        fetchingMore: false,
        data: [],
        list: [],
        lastVisible: null,
        searchState: true
    };

    getData = (text) => {
        let ref = firebase.firestore().collection("items").where("keywords", "array-contains", text).limit(20);
        if(this.state.lastVisible) {
            ref = firebase.firestore().collection("items").where("keywords", "array-contains", text).startAfter(this.state.lastVisible).limit(20);
        }
        ref.get().then( data => {
            let list = [];
            data.forEach(doc => {
                list.push({
                    id: doc.id,
                    ...doc.data()
                })
            });
            this.setState({
                list: [...this.state.list, ...list],
                fetchingMore: false,
                lastVisible: data.docs[data.docs.length-1],
                data: [...this.state.list, ...list]
            })
        });
    };

    onChange = (checked) => {
        this.setState({
            searchState: checked,
            list: [],
            fetchingMore: false,
            lastVisible: null,
            data: []
        });
        if(!checked) {
            let ref = firebase.firestore().collection("shops").doc(this.props.shop.id).collection("items").limit(20);
            ref.get().then( data => {
                let list = [];
                data.forEach(doc => {
                    list.push({
                        id: doc.id,
                        ...doc.data()
                    })
                });
                this.setState({
                    list: [...this.state.list, ...list],
                    fetchingMore: false,
                    lastVisible: data.docs[data.docs.length-1],
                    data: [...this.state.list, ...list]
                })
            });
        }
    };

    onLoadItems = () => {
        let ref = firebase.firestore().collection("shops").doc(this.props.shop.id).collection("items").startAfter(this.state.lastVisible).limit(20);;
        ref.get().then( data => {
            let list = [];
            data.forEach(doc => {
                list.push({
                    id: doc.id,
                    ...doc.data()
                })
            });
            this.setState({
                list: [...this.state.list, ...list],
                fetchingMore: false,
                lastVisible: data.docs[data.docs.length-1],
                data: [...this.state.list, ...list]
            })
        });
    }

    toggleLoading = () => {
        this.setState({
            loading: !this.state.loading
        })
    };


    showNotification = (success, title,message) => {
        notification.open({
            message: title,
            description: message,
            icon: success ? <CheckCircleOutlined className="color-green" /> : <CloseCircleOutlined className="color-red" />,
        });
    }

    showDrawer = (itemState, item) => {
        this.setState({
            visible: true,
            item: item,
            itemState: itemState
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
            item: null
        });
    };

    onDelete = item => {
        deleteShopItem(this.props.shop.id, item.id, res => {
            this.showNotification("success","Successfully deleted item", null)
            this.setState({
                list: this.state.list.filter(val => val.id !== item.id)
            })
        })
    };

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => {
                        this.searchInput = node;
                    }}
                    size="large"
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 360, marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Search
                    </Button>
                    <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: text =>
            this.state.searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[this.state.searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    onSearch = text => {
        this.setState({
            searchText: text,
            list: [],
            fetchingMore: false,
            lastVisible: null
        });
        this.getData(text)
    }

    handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        this.setState({
            searchText: selectedKeys[0],
            searchedColumn: dataIndex,
        });
    };

    handleReset = clearFilters => {
        clearFilters();
        this.setState({ searchText: '' });
    };

    onLoadMore = () => {
        this.setState({
            fetchingMore: true
        });
        this.getData(this.state.searchText)
    }

    render() {
        const { shop, items, categories, shopCategories, shopItems, shopCompanies, companies } = this.props;
        const { searchState, lastVisible, initLoading, fetchingMore, list, item, visible, searchedColumn, searchText, itemState, loading } = this.state;
        const loadMore = lastVisible ? (
            <div
                style={{
                    textAlign: 'center',
                    marginTop: 12,
                    height: 32,
                    lineHeight: '32px',
                }}
            >
                <Button onClick={searchState ?  this.onLoadMore : this.onLoadItems}>Load more</Button>
            </div>
        ) : null;

        const searching = searchedColumn==="name"&&searchText.length>0;
        let tempItems = searching ? items : shopItems;
        let tempCategories = searching ? categories : shopCategories;
        let tempCompanies = searching ? companies : shopCompanies;

        return (
            <div>
                <div>
                    <div className="uk-margin-bottom">
                        <div>
                            <h3 className="uk-h3 uk-margin-remove uk-text-bolder">
                                Shop items
                            </h3>
                            <p className="uk-text-small uk-margin-remove">
                                <Switch defaultChecked onChange={this.onChange} /> { searchState ? "Search state" : "Shop items state"}
                            </p>
                        </div>
                    </div>



                    <div>
                        <div>
                            <Row gutter={12}>
                                <Col span={12}>
                                    <div>
                                        { searchState ?
                                            <Search
                                                placeholder="input search text"
                                                onSearch={this.onSearch}
                                                style={{ width: "100%" }}
                                            />
                                        : null }

                                        <List
                                            className="demo-loadmore-list"
                                            loading={initLoading}
                                            itemLayout="horizontal"
                                            loadMore={loadMore}
                                            dataSource={list}
                                            renderItem={item => (
                                                <List.Item
                                                    actions={[
                                                        <a key="list-loadmore-edit" onClick={() => searchState ? this.showDrawer("add", item) : this.onDelete(item)}>
                                                            { searchState  ?  "Addd" : "Delete"}
                                                        </a>
                                                    ]}
                                                >
                                                    <Skeleton avatar title={false} loading={item.loading} active>
                                                        <List.Item.Meta
                                                            avatar={
                                                                <Avatar src={item.image} />
                                                            }
                                                            title={<a href="https://ant.design">{item.name}</a>}
                                                            description={ `${item.category} | ${item.company} | ${searchState ? item.price.sum/item.price.count : item.price.value}kzt` }
                                                        />
                                                    </Skeleton>
                                                </List.Item>
                                            )}
                                        />
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div>
                                        <ItemDrawer showNotification={this.showNotification} toggleLoading={this.toggleLoading} loading={loading} onClose={this.onClose} item={item} visible={visible} state={itemState} shopId={shop.id} />
                                    </div>
                                </Col>
                            </Row>

                            {/*<Table dataSource={tempItems}>*/}
                            {/*    <Column width="10%" title="Image" dataIndex="image" key="image" render={(image) => (*/}
                            {/*        <img className="uk-border-rounded" src={image} />*/}
                            {/*    )} />*/}
                            {/*    <Column width="25%" title="Name" dataIndex="name" key="name" {...this.getColumnSearchProps('name')}*/}
                            {/*            render={(name) => (*/}
                            {/*                <h4 className="uk-h5 uk-margin-remove">*/}
                            {/*                    { name }*/}
                            {/*                </h4>*/}
                            {/*            )}*/}
                            {/*    />*/}
                            {/*    <Column width="20%" title="Category" dataIndex="category" key="category" filters={tempCategories} onFilter={(value, record) => record.category===value} />*/}
                            {/*    <Column width="15%" title="Company" dataIndex="company" key="company" filters={tempCompanies} onFilter={(value, record) => record.company===value} />*/}
                            {/*    <Column*/}
                            {/*        width="15%"*/}
                            {/*        title="Price"*/}
                            {/*        key="price"*/}
                            {/*        sorter={(a, b) => searching ? (a.price.sum/a.price.count) - (b.price.sum/b.price.count) : a.price.value - b.price.value }*/}
                            {/*        sortDirections={['descend', 'ascend']}*/}
                            {/*        render={(item) => (*/}
                            {/*            <div>*/}
                            {/*                <h5 className="color-green uk-h5 uk-margin-remove">*/}
                            {/*                    { searching&&!item.includes ?*/}
                            {/*                        ("~" + item.price.sum/item.price.count) + "₸"*/}
                            {/*                    : (item.price.value + "₸ / " + item.price.per)}*/}
                            {/*                </h5>*/}
                            {/*            </div>*/}
                            {/*        )} />*/}
                            {/*    <Column width="15%" title="Action" render={(item) => (*/}
                            {/*        <div>*/}
                            {/*            { searching&&!item.includes ?*/}
                            {/*                <Button dataIndex={"id"} onClick={() => this.showDrawer("add", item)} size="small" type="default">*/}
                            {/*                    Add*/}
                            {/*                </Button>*/}
                            {/*                :*/}
                            {/*                <Row gutter={4}>*/}
                            {/*                    <Col>*/}
                            {/*                        <Button dataIndex={"id"} onClick={() => this.showDrawer("edit", item)} size="small" type="default" className="color-orange">*/}
                            {/*                            Edit*/}
                            {/*                        </Button>*/}
                            {/*                    </Col>*/}
                            {/*                    <Col>*/}
                            {/*                        <Popconfirm*/}
                            {/*                            title="Are you sure delete this task?"*/}
                            {/*                            onConfirm={() => this.onDelete(item)}*/}
                            {/*                            okText="Delete"*/}
                            {/*                            cancelText="Cancel"*/}
                            {/*                            dataIndex={"id"}*/}
                            {/*                        >*/}
                            {/*                            <Button size="small" type="default" className="color-red">*/}
                            {/*                                Delete*/}
                            {/*                            </Button>*/}
                            {/*                        </Popconfirm>*/}
                            {/*                    </Col>*/}
                            {/*                </Row>*/}
                            {/*            }*/}
                            {/*        </div>*/}
                            {/*    )} />*/}
                            {/*</Table>*/}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = (state) => {

    let items = [];
    let categories = [];
    let companies = [];
    let shopItems = [];
    let shopCategories = [];
    let shopCompanies = [];
    if(state.firestore.ordered.shopItems) {
        shopItems = state.firestore.ordered.shopItems.map(item => {
            if(!shopCategories.includes(item.category)){
                shopCategories.push(item.category);
            }
            if(item.company && !shopCompanies.includes(item.company)){
                shopCompanies.push(item.company);
            }
            return {
                key: item.id,
                ...item
            }
        })
    }

    if(state.firestore.ordered.items) {
        items = state.firestore.ordered.items.map(item => {
            if(!categories.includes(item.category)){
                categories.push(item.category);
            }
            if(item.company && !companies.includes(item.company)){
                companies.push(item.company);
            }
            const includes = shopItems.find(shopItem => shopItem.id === item.id);
            return {
                key: item.id,
                includes: includes,
                ...item,
                price: includes ? includes.price : (item.price ? item.price : { sum:0, count: 1 }),
                company: includes ? includes.company : (item.company ? item.company : null)
            }
        })
    }



    return {
        auth: state.firebase.auth,
        items: items,
        categories: categories.map(category => {
            return {
                text: category,
                value: category
            }
        }),
        companies: companies.map(company => {
            return {
                text: company,
                value: company
            }
        }),
        shopItems: shopItems,
        shopCategories: shopCategories.map(category => {
            return {
                text: category,
                value: category
            }
        }),
        shopCompanies: shopCompanies.map(company => {
            return {
                text: company,
                value: company
            }
        }),
    }
}

const enhance = compose(
    firestoreConnect(props => [
        // { collection: "shops/" + props.shop.id + "/items", storeAs: "shopItems" },
        // { collection: "items", type: "once" }
    ]),
    connect(mapStateToProps)
);
export default enhance(ShopItems);



// WEBPACK FOOTER //
// ./src/Components/Shop/ShopItems.js